import React from "react";
import lazyPage from "../../../../common/helpers/lazyPage";
import PageLoader from "../../../components/PageLoader";

export default lazyPage(
    "src/front/pages/christmas-tuning/Game/Game.tsx",
    () => import("./Game"),
    <PageLoader isFullPage />,
);
